export default {"src":"/_next/static/media/default-avatar.a47113a6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};